/**
 * Cross-feature scoped field-level API / client validation messages.
 */

export type FieldErrorsByScope = Record<string, Record<string, string>>;

export type FieldErrorsState = {
    byScope: FieldErrorsByScope;
};

export const fieldErrorsInitialState: FieldErrorsState = {
    byScope: {},
};
